<script lang="ts">
  /**
   * Imports
   * ---------------------------------------------------------------------------
   */

  import { convertStatamicAssetToCDN } from "@utils/cdn";
  import type { StatamicAsset } from "@customTypes/statamic";
  import clsx from "clsx";

  /**
   * Props
   * ---------------------------------------------------------------------------
   */

  export let image: StatamicAsset;
  export let small_width: { value: number | string } = { value: 50 };
  export let medium_width: { value: number | string } = { value: 100 };
  export let link: string | null = null;

  /**
   * Data
   * ---------------------------------------------------------------------------
   */

  // NOTE: the full Tailwind style classes are hardcoded so the proper classes
  // will be generated when the source is scanned.
  const widths = {
    8: "w-1/12",
    25: "w-1/4",
    33: "w-1/3",
    50: "w-1/2",
    66: "w-2/3",
    75: "w-3/4",
    100: "w-full",
    "max-content": "w-max",
  };
  const mediumWidths = {
    8: "md:w-1/12",
    25: "md:w-1/4",
    33: "md:w-1/3",
    50: "md:w-1/2",
    66: "md:w-2/3",
    75: "md:w-3/4",
    100: "md:w-full",
    "max-content": "md:w-max",
  };
  const imageClasses = clsx(
    widths[small_width.value as keyof typeof widths],
    mediumWidths[medium_width.value as keyof typeof mediumWidths],
    "object-contain",
    "m-auto md:m-0",
  );
  const imageSource = convertStatamicAssetToCDN(image.id) || "";
  const imageAlt = image.alt;
</script>

<!-- Template ----------------------------------------------------------------->

{#if link}
  <a href={link}>
    <img src={imageSource} class={imageClasses} alt={imageAlt} />
  </a>
{:else}
  <img src={imageSource} class={imageClasses} alt={imageAlt} />
{/if}
